import {
	formatDate,
	startOfDayIso,
	utcToLocalFormatted,
	toSaveDateIso,
	toSaveEndDateIso,
	utcDisplay,
	utcToLocalDate,
	utcToLocalDateNextDay,
	localFromDisplay,
} from "./date";

export function dateFormat(date, format = "MM/DD/YYYY") {
	return formatDate(date, format);
}

export function dateFormatStartDay(date, format = "MM/DD/YYYY") {
	return startOfDayIso(date, format);
}

export function dateStartDate(date, format = null) {
	if (format) {
		return startOfDayIso(date, format);
	} else {
		return startOfDayIso(date);
	}
}

export function isCompleteMonth(utcDt, dtFormat = "MM/DD/YYYY") {
	if (utcDt) {
		return utcToLocalFormatted(utcDt, dtFormat);
	} else {
		return null;
	}
}
export function UTCToLocalDate(date, dtFormat = "MM/DD/YYYY") {
	return utcToLocalFormatted(date, dtFormat);
}

export function toSaveDate(date, format = "MM/DD/YYYY") {
	return toSaveDateIso(date, format);
}

export function toSaveEndDate(date, format = "MM/DD/YYYY") {
	return toSaveEndDateIso(date, format);
}

export function toDisplayTime(date, format = "MM/DD/YYYY") {
	return utcDisplay(date, format);
}

export function toDisplayFullDate(date) {
	return utcToLocalDate(date);
}

export function toDisplayFullDateWithNextDay(date) {
	return utcToLocalDateNextDay(date);
}

export function toDisplayUTCDate(date) {
	return localFromDisplay(date, "MM/DD/YYYY");
}

const HEAVY_PAYLOAD_KEYS = [
	"patientListFromPage",
	"customRangeCombinedData",
	"dbData",
	"dbDataComparison",
	"patientList",
	"patientListComparison",
	"dynamicCards",
	"customTabs",
	"isSpecialComparison",
	"defaultCardShiftData",
	"ninetyDaysData",
	"hospitalData",
	"diffDashboardPatients",
	"customCombineTabData",
	"customDiffrentDashboardData",
	"filterListData",
	"selectedFilterData",
	"facilityPercentage",
	"lockedByFacility",
];

export function filterBodyDate(body) {
	body = body?.filter
		? Object.assign({}, body, {
				timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				filter: {
					startDate: toSaveDate(body?.filter.startDate),
					endDate: toSaveEndDate(body?.filter.endDate),
				},
		  })
		: {};
	for (const key of HEAVY_PAYLOAD_KEYS) {
		delete body[key];
	}
	return body;
}
